(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sultan-paypal-welcome"]) return;
  try {
    
  if (!customElements.get('sultan-paypal-welcome')) {
    class SultanPayPalWelcome extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.message = this.querySelector('.sultan-paypal-welcome__message');
        if (!this.dialog || !this.message || typeof this.dialog.showModal !== 'function') return;
        this.storageKey = 'sultan-paypal-welcome-v1';
        this.dismiss = () => this.dialog.close();
        this.querySelectorAll('[data-paypal-dismiss]').forEach(button => button.addEventListener('click', this.dismiss));
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dismiss(); });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('sultan-paypal-welcome-open');
          if (this.wasShown) {
            try { sessionStorage.setItem(this.storageKey, 'seen'); } catch {}
            this.previousFocus?.focus({ preventScroll: true });
          }
        });
        this.forcePreview = new URLSearchParams(location.search).get('sultan_paypal_preview') === '1';
        if (!this.forcePreview) {
          try { if (sessionStorage.getItem(this.storageKey) === 'seen') return; } catch {}
          if (window.Shopify?.designMode) return;
        }
        this.onVisibility = () => { if (!document.hidden && !this.wasShown && !this.opening) this.waitForSdk(); };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.timer = setTimeout(() => this.waitForSdk(), Number(this.dataset.delay) || 1800);
      }
      waitForSdk(attempt = 0) {
        if (!this.isConnected || document.hidden || this.wasShown || this.opening) return;
        if (document.querySelector('dialog[open]') || document.querySelector('.shopify-pc__banner__dialog')) {
          if (attempt < 30) this.timer = setTimeout(() => this.waitForSdk(attempt + 1), 1000);
          return;
        }
        if (window.PayPalSDK?.Messages) {
          this.openMessage();
        } else if (attempt < 20) {
          this.timer = setTimeout(() => this.waitForSdk(attempt + 1), 500);
        }
      }
      async openMessage() {
        if (this.opening) return;
        this.opening = true;
        this.previousFocus = document.activeElement;
        this.dialog.classList.add('is-loading');
        this.dialog.showModal();
        const timeout = setTimeout(() => this.dismiss(), 12000);
        try {
          await window.PayPalSDK.Messages({
            placement: this.dataset.placement,
            style: { layout: 'text', logo: { type: 'primary', position: 'top' }, text: { size: 16, color: 'white' } },
            onClick: () => this.dismiss()
          }).render(this.message);
          await Promise.all(Array.from(this.querySelectorAll('[data-paypal-option]')).map(element =>
            window.PayPalSDK.Messages({
              offer: element.dataset.paypalOption,
              placement: this.dataset.placement,
              style: { layout: 'text', logo: { type: 'inline' }, text: { size: window.matchMedia('(max-width: 360px)').matches ? 12 : window.matchMedia('(max-width: 480px)').matches ? 14 : 16, color: 'black' } },
              onClick: () => this.dismiss()
            }).render(element)
          ));
          if (!this.dialog.open) return;
          this.wasShown = true;
          this.dialog.classList.remove('is-loading');
          document.documentElement.classList.add('sultan-paypal-welcome-open');
          this.querySelector('[data-paypal-dismiss]').focus({ preventScroll: true });
          if (!this.forcePreview) {
            try { sessionStorage.setItem(this.storageKey, 'seen'); } catch {}
          }
        } catch {
          this.dismiss();
        } finally {
          clearTimeout(timeout);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.dialog?.open) this.dialog.close();
      }
    }
    customElements.define('sultan-paypal-welcome', SultanPayPalWelcome);
  }

  } catch(e) { console.error(e); }
})();
})();
